import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarFallback,
  AvatarImage,
  Badge,
} from '@e2n/ui';
import {
  getWiederholungStringFromTerminWiederholung,
  Termin,
} from '@/domain/arbeitszeiten/entities/Termin';
import { getTimeDisplayFromDate, markierungMapper } from '@/utils';
import { faCalendarStar, faDash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

type StyleProps = CSSProperties & {
  '--border-color': CSSProperties['color'];
};

export function TermineAccordion({ termine }: { termine: Termin[] }) {
  const { t } = useTranslation();

  return (
    <Accordion type="single" collapsible className="w-full">
      {termine.map((termin) => (
        <AccordionItem
          value={termin.id}
          key={termin.id}
          className="last:border-0 border-neutrals-500">
          <AccordionTrigger className="hover:no-underline" icons={false}>
            <div className="flex gap-2 items-center justify-between w-full">
              <div className="flex items-center gap-4">
                <Avatar
                  className="w-9 h-9 border-2 border-[--border-color] "
                  style={
                    {
                      '--border-color': termin.markierung
                        ? markierungMapper[termin.markierung].base
                        : '',
                    } as StyleProps
                  }>
                  <AvatarImage src={termin.bildUrl} alt={termin.bildName} />
                  <AvatarFallback>
                    <FontAwesomeIcon icon={faCalendarStar} size="lg" />
                  </AvatarFallback>
                </Avatar>
                <span className="font-semibold">{termin.titel}</span>{' '}
              </div>
              <div className="flex items-center gap-1">
                <div>{getTimeDisplayFromDate(termin.beginn)}</div>
                <FontAwesomeIcon icon={faDash} />
                <div>{getTimeDisplayFromDate(termin.ende)}</div>
              </div>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="flex gap-2 flex-col items-start justify-end">
              <Badge>
                {getWiederholungStringFromTerminWiederholung(
                  termin.wiederholung,
                )}
              </Badge>
              {termin.beschreibung && termin.beschreibung.length > 0 ? (
                <p className="line-clamp-3">{termin.beschreibung}</p>
              ) : (
                <Badge className="bg-neutrals-200 hover:bg-neutrals-200 text-neutrals-800">
                  {t(
                    'domain.arbeitszeiten.uebersicht.termine.beschreibungFehlend',
                  )}
                </Badge>
              )}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
